import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { AvatarVO } from "./AvatarVO";
import { VisualVO } from "./VisualVO";

export class SeatVO extends VisualVO {
    public static STATE_FREE: number = -1;

    public static STATE_FOLD: number = 1;
    public static STATE_CHECK: number = 2;
    public static STATE_CALL: number = 3;
    public static STATE_RAISE: number = 4;
    public static STATE_ALLIN: number = 5;
    public static STATE_WINNER: number = 6;
    public static STATE_ACTIVE: number = 7;	// ist gerade dran
    public static STATE_INACTIVE: number = 8;	// war noch nicht dran
    public static STATE_STILWAITING: number = 8;	//wartet auf nächste Runde

    public winTrophy: boolean = false;	// Hat Tunier gewonnen

    public seated: boolean = false;
    public userId: number = -1;
    public playerId: number = -1;
    //		public var chips:Number = 0;	// Restgeld für das Spiel
    public tableChips: number = 0; // Aktueller Einsatz auf dem Tisch
    public handChips: number = NaN;
    public name: string;
    public level: number = 0;
    public avatar: AvatarVO;
    public stateGame: number = 0;	// Letzer Spielstatus: Call, Raise etc.
    public statePlayer: number = 0;	// Spielerstatus: Dealer, SmallBlind, BigBlind
    public giftId: number = -1;
    public winnerC1: string; //karte 1 des gewinners
    public winnerC2: string; //karte 2 des gewinners
    public zombie: number = 0; // 0 normal, 1 zombie

    constructor() {
        super();
    }
}
classImplementsInterfaces(SeatVO, "IInventoryVO");
